import React from "react";
import ReactDOM from "react-dom";
import PreTest from "../components/PreTest";
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderPreTest = (elementId) => {
  const element = document.getElementById(elementId);
  if (element) {

    initializeI18n()
      .then((i18nInstance) => {
        ReactDOM.render(<PreTest />, element);
      })
      .catch(error => {
        console.error("Failed to initialize i18n before rendering PreTest:", error);
      });

  } else {
    console.error(`Element with ID ${elementId} not found.`);
  }
};
